import { TrussDefinitionType, TrussEnvelope } from '@paragon/contract-library';

import { TrussEnvelopePersistedDefaultProperties } from './types';

export const DEFAULT_PROFILE_TRUSS_THICKNESS = 1.5;
export const DEFAULT_FEATURE_PATTERN_TRUSS_THICKNESS = 3.5;

export const INITIAL_TRUSS_ENVELOPE_PROPERTIES: Record<TrussDefinitionType, TrussEnvelopePersistedDefaultProperties> = {
  Profile: {
    justification: 'Front',
    thickness: DEFAULT_PROFILE_TRUSS_THICKNESS,
    numberOfPlies: 1,
  },
  FeaturePattern: {
    justification: 'Center',
    thickness: DEFAULT_FEATURE_PATTERN_TRUSS_THICKNESS,
    numberOfPlies: 1,
  },
};

export const DEFAULT_FEATURE_PATTERN_TRUSS_ADDITIONAL_CUTS: Partial<TrussEnvelope> = {
  containerLevel: 'NotCapped',
  capLevelOne: 0,
  capLevelTwo: 0,
  leftBevelCut: null,
  rightBevelCut: null,
  topCuts: [],
  bottomCuts: [],
};
